import { DeepPartial } from '@apollo/client/utilities'
import type { ContractsContractVersionApprovableMetadataFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

import { workingHoursFrequency } from './helpers'

export const getContractsContractVersionMetadata = (
  data: DeepPartial<ContractsContractVersionApprovableMetadataFragment>
) => {
  const accessLocale = data.employee?.access?.locale ?? 'en'

  const jobTitleDisplay = data.jobTitle ? data.jobTitle : undefined

  const salaryDisplay =
    data.salaryAmount != null
      ? MoneyWithCurrency({
          amount: data.salaryAmount,
          currency: data.employee?.legalEntity?.currency,
          locale: accessLocale,
        })
      : undefined

  const workingHoursDisplay =
    data.workingHours && data.workingHoursFrequency
      ? i18n.t('contract_versions.time.working_hours.description', {
          hours: data.workingHours / 100,
          frequency: workingHoursFrequency(data.workingHoursFrequency),
        })
      : undefined

  return [jobTitleDisplay, salaryDisplay, workingHoursDisplay].filter(Boolean)
}
